export default __webpack_public_path__ + "static/media/quote.60f89cf2.svg";